module.exports = __webpack_public_path__ + "img/top_bg.34c1273f.png";